import script from "./TrainingsPage.vue?vue&type=script&lang=ts&setup=true"
export * from "./TrainingsPage.vue?vue&type=script&lang=ts&setup=true"

import "./TrainingsPage.vue?vue&type=style&index=0&id=746df630&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-746df630"]])

export default __exports__